// JS INDUSTRIES SHAPERBUDDY <-> SHOPIFY CONNECTOR
              // PERISCOPE 2022

              // Helper function to escape CSS selector special characters
              function escapeCSSSelector(selector) {
                return selector.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, '\\$&');
              }

              // Add Board to cart
              function addToCart(varid){
                document.querySelector('#b_'+varid+' button').innerHTML = '<div class="lds-dual-ring"></div>';

                  let itemList = {
                    'items': [{
                      'id': varid,
                      'quantity': 1
                    }]
                  };

                  fetch(window.Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(itemList)

                }).then(response => {
                  document.querySelector('#b_'+varid+' button').innerHTML = '<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>';
                
                }).then(response => {
                  setTimeout(function(){ window.location.href = "/cart"; }, 800);
                
                }).catch((error) => {
                  console.error('Error:', error);
                });
              }

              // Add to Custom Order
              function addToCustomOrder(model, length, width, thickness){
                window.location.href = '/pages/custom-order?id_surfboardmodel='+model+'&co_length='+length+'&co_width='+width+'&co_thickness='+thickness+'&co_technology='+coTech;
              }

              // Toggle Fin System Filter (AUS Site Approach - uses renderBoards)
              function toggleFins(filter=null, button = null){
                if(!filter || !window.currentFilters){ return; }
                // Normalize incoming label to canonical token
                const f = (filter || '').toString().toUpperCase();
                const finFilter = f.indexOf('FUT') > -1 ? 'Futures' : (f.indexOf('FCS') > -1 ? 'FCS' : '');
                if(!finFilter){ return; }
                
                // Check if this fin system exists for the current construction
                var currentConst = window.currentFilters.construction;
                if(!window.boardData || !window.boardData[currentConst] || !window.boardData[currentConst][finFilter]){
                  console.warn('Fin system "'+finFilter+'" not available for construction "'+currentConst+'"');
                  return; // Don't render if this combo doesn't exist
                }
                
                // Re-render with new fin filter
                if(typeof renderBoards === 'function'){
                  renderBoards(currentConst, finFilter, window.currentFilters.colour, window.currentFilters.finSetup);
                } else {
                  console.error('renderBoards function not found');
                }
              }

              // Toggle Fin Setup Filter (AUS Site Approach - uses renderBoards)
              function toggleFinSetup(filter=null, button = null){
                // Guard: don't allow selecting a fin setup that isn't available
                // for the current construction. This catches programmatic calls
                // (e.g. the post-render toggleFinSetup(window.initialFinSetup))
                // that would otherwise force the global default 3 FIN onto a
                // construction like HYFI that only stocks 5 fin.
                if(filter && window.currentFilters && typeof window.updateFinSetupOptions === 'function'){
                  var optBtn = document.querySelector('.fin-setup-option [data-fin-option="' + String(filter).charAt(0) + '"]');
                  if(optBtn && optBtn.style.display === 'none'){
                    var redirected = window.updateFinSetupOptions(window.currentFilters.construction, null);
                    console.warn('toggleFinSetup: "' + filter + '" unavailable for construction "' + window.currentFilters.construction + '", using "' + redirected + '"');
                    filter = redirected;
                  }
                }

                // Keep radio/active UI state in sync even for programmatic calls.
                const finInputs = document.querySelectorAll('.fin-setup-option .fin-setup-value');
                finInputs.forEach(input => {
                  const item = input.closest('.product-variant__item');
                  if(item) item.classList.remove('active');
                  if(filter){
                    input.checked = input.value === filter;
                  }
                });
                if(button){
                  const activeItem = button.closest('.product-variant__item');
                  if(activeItem) activeItem.classList.add('active');
                }else if(filter){
                  const selectedInput = document.querySelector('.fin-setup-option .fin-setup-value[value="' + filter + '"]');
                  if(selectedInput){
                    selectedInput.checked = true;
                    const selectedItem = selectedInput.closest('.product-variant__item');
                    if(selectedItem) selectedItem.classList.add('active');
                  }
                }

                if(!window.currentFilters){ return; }
                
                // Re-render with new fin setup filter (null = show all fin setups)
                if(typeof renderBoards === 'function'){
                  renderBoards(window.currentFilters.construction, window.currentFilters.finSystem, window.currentFilters.colour, filter);
                } else {
                  console.error('renderBoards function not found');
                }
              }

              function doSomething(object, something){
                const escapedSelector = escapeCSSSelector(something);
                
                // Get all INSTOCK items with the same data-name that are currently visible (show-colour)
                // This ensures we only hide duplicate in-stock items, not sizegrid (made-to-order) items
                const sameDataNameItems = document.querySelectorAll(".instock."+escapedSelector+".show-colour");
                
                // Only hide other items with the same data-name, not the current object
                sameDataNameItems.forEach(e => {
                  if(e !== object){
                    e.classList.add("hide-dimm");
                  }
                });
                object.classList.remove("hide-dimm");
              }

              // Hide duplicate in-stock boards (same dimensions, different colors)
              function hideDuplicateInstockBoards(){
                // Get all visible in-stock boards
                const visibleInstock = document.querySelectorAll(".instock.show-colour:not(.hide-fin-setup)");
                
                // Track boards by signature (dims + construction) to find duplicates
                const boardsBySig = new Map();
                
                visibleInstock.forEach(e => {
                  const sig = e.getAttribute('data-sig-rt') || e.getAttribute('data-sig');
                  if(!sig) return;
                  
                  // Parse signature: format is "dims|construction|finToken"
                  const parts = sig.split('|');
                  if(parts.length < 2) return;
                  
                  const dims = parts[0]; // dimensions identifier
                  const construction = parts[1]; // construction type
                  const baseSig = dims + '|' + construction;
                  
                  // Track boards by base signature (dims + construction)
                  if(!boardsBySig.has(baseSig)){
                    boardsBySig.set(baseSig, []);
                  }
                  boardsBySig.get(baseSig).push(e);
                });
                
                // For each signature group, keep only the first board visible, hide the rest
                boardsBySig.forEach((boards, baseSig) => {
                  if(boards.length > 1){
                    // Multiple boards with same dimensions - keep first, hide rest
                    for(let i = 1; i < boards.length; i++){
                      boards[i].classList.add("hide-dimm");
                    }
                  }
                });
              }

              // Ensure made-to-order (sizegrid) rows are hidden when a matching in-stock row is visible
              function hideSizegridDuplicates(){
                // Base: visible instock by colour (not hidden by dimm or fin-setup filters)
                let selector = ".instock.show-colour:not(.hide-dimm):not(.hide-fin-setup)";
                // If fin filter applied, restrict to current fin selection
                if(document.querySelector(".instock.show-fins")){
                  selector = ".instock.show-colour.show-fins:not(.hide-dimm):not(.hide-fin-setup)";
                }
                // If construction filter applied, restrict to current construction selection
                if(document.querySelector(".instock.show-const")){
                  // keep both flags if present
                  selector = selector.replace(".show-colour", ".show-colour.show-const");
                }
                // Note: computeRuntimeSig function is not defined, but code falls back to data-sig if data-sig-rt is missing
                const visibleInstock = document.querySelectorAll(selector);

                // First, clear all hide-dimm from sizegrid items to start fresh
                // But preserve hide-fin-setup state (don't clear that)
                document.querySelectorAll('.sizegrid').forEach(sg => {
                  // Only clear hide-dimm, not hide-fin-setup
                  sg.classList.remove("hide-dimm");
                });

                // Build a set of visible in-stock board signatures for quick lookup
                const visibleInstockSigs = new Set();
                visibleInstock.forEach(e => {
                  const sig = e.getAttribute('data-sig-rt') || e.getAttribute('data-sig');
                  if(!sig) return;
                  
                  // Parse signature: format is "dims|construction|finToken"
                  const parts = sig.split('|');
                  if(parts.length < 2) return;
                  
                  const dims = parts[0]; // dimensions identifier
                  const construction = parts[1]; // construction type
                  
                  // Store base signature (dims + construction) for matching
                  const baseSig = dims + '|' + construction;
                  visibleInstockSigs.add(baseSig);
                });

                // Now hide all sizegrid boards that match any visible in-stock board
                // This prevents duplicates regardless of fin system or fin setup
                const visibleSizegridSigs = new Map(); // Track visible sizegrid boards by base signature
                
                document.querySelectorAll('.sizegrid').forEach(sg => {
                  // Skip if already hidden by fin-setup filter (has specific fin setup that doesn't match)
                  if(sg.classList.contains('hide-fin-setup')){
                    return;
                  }
                  
                  const sgSig = sg.getAttribute('data-sig');
                  if(!sgSig) return;
                  
                  const sgParts = sgSig.split('|');
                  if(sgParts.length >= 2){
                    const sgDims = sgParts[0];
                    const sgConstruction = sgParts[1];
                    const sgBaseSig = sgDims + '|' + sgConstruction;
                    
                    // If this sizegrid board matches any visible in-stock board, hide it
                    if(visibleInstockSigs.has(sgBaseSig)){
                      sg.classList.add("hide-dimm");
                    } else {
                      // Track visible sizegrid boards to detect duplicates among themselves
                      // Keep only the first one visible per dimension set
                      if(visibleSizegridSigs.has(sgBaseSig)){
                        // This is a duplicate sizegrid board (same dimensions, different fin system)
                        // Hide it to prevent duplicates
                        sg.classList.add("hide-dimm");
                      } else {
                        // First sizegrid board with these dimensions - keep it visible
                        visibleSizegridSigs.set(sgBaseSig, sg);
                      }
                    }
                  }
                });
              }

              // Toggle Colour Filter (AUS Site Approach - uses renderBoards)
              function toggleColour(filter=null, button = null){
                if(!window.currentFilters){ return; }
                // Re-render with new colour filter (null = show all colours)
                if(typeof renderBoards === 'function'){
                  renderBoards(window.currentFilters.construction, window.currentFilters.finSystem, filter, window.currentFilters.finSetup);
                } else {
                  console.error('renderBoards function not found');
                }
              }

              // Normalize construction option value to boardData key (e.g. "PE -" -> "PE", "HYFI 2.0" -> "HYFI")
              // Must match keys used when building boardData in main-product.liquid
              function normalizeConstruction(value){
                if(!value || typeof value !== 'string') return value;
                var v = value.toUpperCase().trim();
                if(v.indexOf('HYFI') > -1) return 'HYFI';
                if(v.indexOf('PE') > -1) return 'PE';
                if(v.indexOf('PU') > -1) return 'PU';
                if(v.indexOf('CARBO') > -1) return 'Carbotune';
                if(v.indexOf('EPS') > -1) return 'EPS';
                if(v.indexOf('FOIL') > -1) return 'FOIL';
                if(v.indexOf('SOFT') > -1) return 'SOFT';
                return value;
              }

              // Toggle Construction Filter (AUS Site Approach - uses renderBoards)
              function toggleConst(filter=null, button = null){
                if(!filter || !window.currentFilters){ return; }
                var construction = normalizeConstruction(filter);
                
                // Update coTech for addToCustomOrder function
                if(construction === 'PU'){ window.coTech = 47; }
                else if(construction === 'PE'){ window.coTech = 989; }
                else if(construction === 'EPS'){ window.coTech = 466; }
                else if(construction === 'HYFI'){ window.coTech = 1483; }
                else if(construction === 'Carbotune'){ window.coTech = 1481; }
                
                // Get first available fin for this construction, or keep current
                var newFin = window.currentFilters.finSystem;
                if(window.boardData && window.boardData[construction]){
                  var availableFins = Object.keys(window.boardData[construction]);
                  if(availableFins.length > 0 && (!newFin || !availableFins.includes(newFin))){
                    newFin = availableFins[0];
                  }
                }
                
                // Refine 3/5 FIN visibility for this construction and validate the
                // current fin setup selection (e.g. hide 3 FIN + switch to 5 FIN
                // when HYFI is selected, since HYFI has no 3 fin stock).
                var validFinSetup = window.currentFilters.finSetup;
                if(typeof window.updateFinSetupOptions === 'function'){
                  validFinSetup = window.updateFinSetupOptions(construction, window.currentFilters.finSetup);
                }

                // Re-render with new construction filter (use normalized key so boardData lookup succeeds)
                if(typeof renderBoards === 'function'){
                  renderBoards(construction, newFin, window.currentFilters.colour, validFinSetup);
                } else {
                  console.error('renderBoards function not found');
                }
              }

            
              // Get Board Size Grid
              async function getBoards(model) {
                // Remove tail shape variations from model name before API call
                // Shaperbuddy doesn't include tail shape in model names
                // Common tail shapes: "Squash Tail", "Swallow Tail", "Round Tail", "Squashtail", etc.
                let cleanedModel = model;
                
                // Remove tail shape patterns (case-insensitive)
                const tailShapePatterns = [
                  /\s+Squash\s+Tail\s+/gi,
                  /\s+Swallow\s+Tail\s+/gi,
                  /\s+Round\s+Tail\s+/gi,
                  /\s+Squashtail\s+/gi,
                  /\s+Swallowtail\s+/gi,
                  /\s+Roundtail\s+/gi,
                  /\s+Squash\s+tail\s+/gi,
                  /\s+Swallow\s+tail\s+/gi,
                  /\s+Round\s+tail\s+/gi
                ];
                
                tailShapePatterns.forEach(pattern => {
                  cleanedModel = cleanedModel.replace(pattern, ' ');
                });
                
                // Clean up any double spaces and trim
                cleanedModel = cleanedModel.replace(/\s+/g, ' ').trim();
                
                // Only log if the model was actually changed
                if(cleanedModel !== model) {
                  console.log('[Shaperbuddy] Model name cleaned:', model, '->', cleanedModel);
                }
                
                const resp = await fetch(`https://js-periscope-buddy.herokuapp.com/board-options-us.php?model=`+encodeURIComponent(cleanedModel), {
                    method: 'GET'
                });

                const data = await resp.json();
                
                if(data.boards != null) {
                  return data;
                }
              }


              // Get Board Size Grid
              async function getVolume(productId) {

                var myHeaders = new Headers();
                myHeaders.append("X-Shopify-Storefront-Access-Token", "86cfe01325b4ed8b7bdd820b9eb418c3");
                myHeaders.append("Content-Type", "application/graphql");
                myHeaders.append("Cookie", "_shopify_y=12ae615c-9c74-4887-934f-a2080efa0d99; _y=12ae615c-9c74-4887-934f-a2080efa0d99; localization=AU; secure_customer_sig=");

                var raw = "{\n  product(id: \"gid://shopify/Product/"+productId+"\") {\n      volume: metafield(namespace: \"surfboard\", key: \"volume\") {\n        value\n      }\n  }\n}";

                var requestOptions = {
                  method: 'POST',
                  headers: myHeaders,
                  body: raw,
                  redirect: 'follow'
                };

                const resp = await fetch("https://js-industries-aus.myshopify.com/api/2021-07/graphql.json", requestOptions);

                const data = await resp.json();

                
                return data;
              }